export default "__VITE_ASSET__CgyzZyAA__"